module.exports = __webpack_public_path__ + "img/shopify-logo-sm.9f024221.png";